import { Component, ViewChild } from '@angular/core';
import {
    Content,
    Events,
    IonicPage,
    NavController,
    NavParams,
    Refresher,
    Tabs,
} from 'ionic-angular';
import { ShopQueueComponent } from '../../components/shop-queue/shop-queue';
import { ShopAboutComponent } from '../../components/shop-about/shop-about';
import { ShopLocationsComponent } from '../../components/shop-locations/shop-locations';
import { ShopCutsComponent } from '../../components/shop-cuts/shop-cuts';
import { HttpClient } from '@angular/common/http';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { TabsServiceProvider } from "../../providers/tabs-service/tabs-service";
import { TeamServiceProvider } from "../../providers/team-service/team-service";
import { StatusBar } from '@ionic-native/status-bar';

@IonicPage()
@Component({
    selector: 'page-shop',
    templateUrl: 'shop.html',
})
export class ShopPage {
    loading: boolean;
    errors: {};
    queue = ShopQueueComponent;
    about = ShopAboutComponent;
    locations = ShopLocationsComponent;
    cuts = ShopCutsComponent;
    shopTab: string = "queue";
    shop: any;
    shopId: any;
    showLocations: boolean;
    isRefresh: boolean = false;

    @ViewChild(Refresher) refresher: Refresher;
    @ViewChild(Content) content: Content;


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public events: Events,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        private teamProvider: TeamServiceProvider,
        private tabsService: TabsServiceProvider,
        private teamService: TeamServiceProvider,
        public statusBar: StatusBar
    ) { 
        this.shop = navParams.get('shop');
        this.shopId = navParams.get('shopId');

        this.events.subscribe('booking:badge+', () => {
            this.loading = true;

            this.getData().then(() => {
                this.loading = false;
            });
        });

    }

    public goBack() {
        this.tabsService.show();
        this.navCtrl.pop();
      }


    public backButton() {
        this.tabsService.show();
        this.navCtrl.pop();
    }

    ionViewWillEnter() {
        this.statusBar.overlaysWebView(true);
        this.loading = true;

        this.getData().then(() => {
            this.loading = false;
        }).catch(error => {
            this.loading = false;
        });
        
        this.tabsService.show();
    }

    getShop() {
        return new Promise((resolve, reject) => {
            let shopId;
            //@todo refactor this into a method
            if (this.teamProvider.shopId) {
                // shopId = this.teamProvider.shopId ? this.teamProvider.shopId : this.shop.id;
                // shopId = this.shop ? this.shop.id : this.teamProvider.shopId;
                shopId = this.shopId ? this.shopId : (this.shop.id ? this.shop.id : this.teamProvider.shopId);
            } else {
                shopId = this.shopId ? this.shopId : (this.shop ? this.shop.id : localStorage.getItem('webShopId'));
            }

            this.http.get(`/teams/${shopId}`).subscribe(
                (shop: any) => {
                    return resolve(shop);
                },
                (error) => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject();
                },
                () => {
                },
            );
        });
    }

    getLocations(shop) {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.shop.owner_id}/location`).subscribe(
                (locations: any) => {
                    this.shop = shop;
                    this.shop.locations = this.filterLocations(locations);
                    this.showLocations = this.shop.locations.length > 1;
                    return resolve(locations);
                },
                (error) => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error);
                },
                () => {
                },
            );
        });
    }

    private filterLocations(locations: any[]): any[] {
        return locations.filter((location) => location.settings
            && location.settings.shop_type === this.shop.settings.shop_type
            && location.id !== this.shop.id);
    }
    getHolidays(shop) {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${shop.id}/staff-holiday`).subscribe(
                (holidays: any) => {
                    this.shop = shop;
                    if (this.shop.users) {
                        this.shop.users.forEach((user, index) => {
                            this.shop.users[index].holidays = [];
                            if (holidays[user.id]) {
                                this.shop.users[index].holidays = holidays[user.id];
                            }
                        });

                        // All the available staff for the shop before being filtered by availability
                        this.shop.all_staff = this.shop.users;
                    
                        this.teamService.filterAvailableUsers(this.shop).then(filteredShopAvailableUsers => {
                            this.shop = filteredShopAvailableUsers;
                        });
                    }
                    resolve(true);
                },
                (error) => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    reject(error);
                },
                () => {
                },
            );
        });
    }

    getData() {
        return new Promise((resolve) => {
            this.getShop().then((shop) => {
                this.getHolidays(shop).then(() => {
                    this.getLocations(shop).then((res) => {
                        resolve(true);
                    });
                });
            });
        });
    }

    pullToRefresh() {
        this.getData().then(() => {
            this.teamService.isRefresh.next(true);
            this.refresher.complete();
        });
    }
    scrollContent(event) {
        setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
    }

    ionViewWillLeave() {
        this.statusBar.overlaysWebView(false);
    }

    ionViewDidLeave(): void {
      this.statusBar.overlaysWebView(false);
    }


}



// WEBPACK FOOTER //
// ./src/pages/shop/shop.ts